import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { UtilitesService } from '../services/utilities.services';
import { Router } from '@angular/router';
@Injectable({
  providedIn: 'root'
})
export class DxAuthGuard implements CanActivate {
  constructor(private router: Router, private utilitesService: UtilitesService) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.utilitesService.isDxLoggednIn()) {
      return true;
    } else {
      this.router.navigate(['digitalXchange/signin']);
      return false;
    }
  }
}
